import {Button, DropdownTag, Label, openDialog} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import {useGetUserQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {useUserActivationDropdownParams} from '../hooks/useUserActivationDropdownParams';
import {EditUserPasswordForm} from './EditUserPasswordForm';

interface UserCredentialsProps extends RequiredTestIdProps {
  userId: string;
}
export function UserCredentials(props: UserCredentialsProps) {
  const {data: user} = useGetUserQuery({id: props.userId});

  const {colorScheme, dropdownItems, label} = useUserActivationDropdownParams(user);

  const handleChangePassword = () =>
    openDialog(
      <EditUserPasswordForm
        userId={props.userId}
        data-testid={suffixTestId('EditUserPasswordForm', props)}
      />,
      {
        title: i18n.t('entity.user.labels.changePassword'),
      }
    );

  return (
    <VStack spacing={4}>
      <HStack spacing={2}>
        <DropdownTag
          dropdownItems={dropdownItems}
          label={label}
          colorScheme={colorScheme}
          size="large"
        />
        <Button
          title={i18n.t('page.login.actions.resetPassword')}
          variant="ghostLink"
          leftIcon="action/lock"
          onClick={handleChangePassword}
        />
      </HStack>

      <VStack>
        <Label>{i18n.t('entity.user.labels.emailUsername')}</Label>
        <Text>{user?.email}</Text>
      </VStack>
    </VStack>
  );
}
